
export const updateCart = ({
	commit
}, { item, quantity, isAdd }) => {
	// TODO: Call service
	commit('UPDATE_CART', { item, quantity, isAdd });
	if (isAdd) {
		let message_obj = {
			message: `Add ${item.name} to cart successfully`,
			messageClass: "success",
			autoClose: true
		}
		commit('ADD_MESSAGE', message_obj);
	}
}

// export const removeItemInCart = ({ commit }, { item }) => {
// 	commit('REMOVE_CART_ITEM', { item });
// }

// export function listenToProductList({ commit }) {
// 	return ref.child("products").on('value', (products) => {
// 		commit('UPDATE_PRODUCT_LIST', products.val());
// 	});
// }

// export function getShoppingCart({ commit }, { uid, currentCart }) {
// 	if (uid) {
// 		return ref.child("cart/" + uid).once('value').then((cart) => {
// 			// console.log(cart.val());
// 			if (cart.val() && (!currentCart || currentCart.length == 0)) {
// 				commit('SET_CART', cart.val());
// 			}
// 		});
// 	} else {
// 		// console.log("User has not logged in");
// 	}
// }

// export function saveShoppingCart(_, { uid, cartItemList }) {
// 	// console.log("ACTIONS saveShoppingCart");
// 	// console.log("CART DATA", cartItemList);
// 	return ref.child("cart/" + uid).set(cartItemList);
// }

// export function saveToTransaction(_, { uid, cartItemList }) {
// 	let newTransactionKey = ref.child("transactions").push().key;
// 	var newTransaction = {}
// 	newTransaction['/transactions/' + uid + '/' + newTransactionKey] = cartItemList;
// 	return ref.update(newTransaction);
// }
